export default __webpack_public_path__ + "static/media/react.faed27e8.png";